import { redirectToLoginPage } from '@a6tr/domains/authentication/login';
import { clearSessionToken } from '@a6tr/domains/authentication/session';
import {
	getApiErrorDetails,
	isExpectedApiError,
	isNetworkError,
} from '@a6tr/lib/apiError';
import { toastQueue } from '@a6tr/lib/toast';
import { Code } from '@connectrpc/connect';
import * as Sentry from '@sentry/react';

import i18n from '../i18n/i18n';

export function handleApiError(
	error: unknown,
	customMessage?: string,
	{ toast = true }: { toast?: boolean } = {},
) {
	const { connectError, code, codeName, requestId, errorCode } =
		getApiErrorDetails(error);

	if (code === Code.Canceled || code === Code.NotFound) {
		return;
	}

	if (code === Code.Unauthenticated) {
		clearSessionToken();
		redirectToLoginPage();
		return;
	}

	if (!isExpectedApiError(code) && !isNetworkError(connectError)) {
		Sentry.captureException(connectError, {
			tags: {
				request_id: requestId,
				connect_code: codeName,
				error_code: errorCode,
			},
		});
	}

	if (!toast) {
		return;
	}

	const title =
		customMessage ||
		connectError.rawMessage ||
		i18n.t('common.api.genericError');
	toastQueue.add(
		{ type: 'error', title, reference: requestId },
		{ timeout: requestId ? 10000 : 5000 },
	);
}
